// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Dba-z","disabled":"Eba-z","label":"Fba-z"};